import * as ng from 'angular';
import * as xml2js from 'xml2js';
import {DocumentStatus} from '../../../../../commons/document-status';
import {PreviewService} from '../../../../../services/preview.service';
import {ArchiSmallServices} from '../../../../../services/archismall.service';
import {FileService} from '../../../../../services/file.service';
import {StoreService} from '../../../../../services/store.service';
import {AlertService} from '../../../../../services/ui/alert.service';
import {TableHeaderItem} from '../../../../../commons/components/table-component/domain/table-header-item';
import {IFatturaAttivaItem} from '../../../../../commons/interfaces/invoices/attive';
import {IResultResponse} from '../../../../../commons/interfaces/IResultResponse';

interface IFilter {
  user: string;
  _id: string;
  status: string;
  number: string;
  idSdi: string;
  sendingId: string;
  object: string;
  dataFrom: string;
  dataTo: string;
  cessionary: string;
  fiscalId: string;
  fiscalCode: string;
  receiverCode: string;
  reference: string;
  onlyLastVersion: true;
  invoice_type: string;
  pageNumber: number;
  pageSize: number;
  option?: string;
}

interface ISettings {
  filter: IFilter;
  sortField: string;
  sortDirection: number;
  pageSizes: number[];
  itemsCount?: number;
}

export const VisualizzaStatoFatturePRComponent = {
  template: require('./visualizza-stato-fatture-pr.html'),
  controller: class VisualizzaStatoFatturePRController {

    static $inject: string[] = [
      '$scope',
      '$rootScope',
      '$state',
      'ArchiSmallServices',
      'FileService',
      'StoreService',
      'AlertService',
      '$sce',
      '$uibModal',
      '$stateParams',
      'PreviewService'
    ];

    private pageHeader: string;
    private trusted: any;

    private headerColumns: Array<TableHeaderItem>;

    constructor(
      private $scope: {
        settings: ISettings,
        items: IFatturaAttivaItem[],
        moreDataToLoad: boolean,
        statusList: string[],
        selectedItem: IFatturaAttivaItem,
        selectedItems: string[],
        selectedFatture: IFatturaAttivaItem[],
        [key: string]: any
      },
      private $rootScope: any,
      private $state: ng.ui.IStateService,
      private archiSmallServices: ArchiSmallServices,
      private fileService: FileService,
      private storeService: StoreService,
      private alertService: AlertService,
      private $sce: ng.ISCEService,
      private $uibModal: ng.ui.bootstrap.IModalService,
      private $stateParams: ng.ui.IStateParamsService,
      private _previewService: PreviewService
    ) {
      this.pageHeader = 'Fatture Trasmesse PR';
      $scope.selectedItems = [];
      $scope.items = [];
      $scope.selectedFatture = [];
      $scope.moreDataToLoad = true;
      let processingRequest = false;

      this.headerColumns = [
        {key: 'status', label: 'Stato', ratio: '12', isSortable: true},
        {key: 'hasAttachment', label: 'Allegati', ratio: '10', isSortable: true},
        {key: 'number', label: 'N. fattura', ratio: '10', isSortable: true},
        {key: 'idSdi', label: 'Id Sdi', ratio: '8', isSortable: true},
        {key: 'sendingId', label: 'Progr. invio', ratio: '6', isSortable: true},
        {key: 'object', label: 'Oggetto', ratio: '10', isSortable: true},
        {key: 'date', label: 'Data', ratio: '11', isSortable: true},
        {key: 'cessionary', label: 'Destinatario', ratio: '12', isSortable: true},
        {key: 'fiscalId', label: 'P.Iva', ratio: '6', isSortable: true},
        {key: 'fiscalCode', label: 'Codice Fiscale', ratio: '10', isSortable: true},
        {key: 'reference', label: 'Riferimento', ratio: '6', isSortable: true},
        {key: 'action', label: 'Azioni', ratio: '9', isSortable: false}
      ];

      this.trusted = {};

      $scope.documentStatuses = [
        {name: '', class: ''},
        {name: 'Versato', class: 'label-primary'},
        {name: 'Conservato', class: 'label-success'},
        {name: 'Presa in carico', class: 'label-warning'},
        {name: 'Negativo', class: 'label-danger'},
        {name: 'Da Verificare', class: 'label-info'},
        {name: 'ERRORE TRASMISSIONE', class: 'label-danger'},
        {name: 'SCARTATA DA ARCHISMALL', class: 'label-danger'}
      ];

      $scope.openVisualizzaFilterModal = (size) => {
        let VisualizzaFilterModalInstance = $uibModal.open({
          animation: true,
          component: 'visualizzaPRFilterComponent',
          size: size,
          windowClass: 'center-modal',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            filter: () => {
              return $scope.settings;
            },
            selected: () => {
              return $scope.selectedItems;
            }
          }
        });
        VisualizzaFilterModalInstance.result.then((settings) => {
          if (settings !== undefined) {
            $scope.settings = settings;
            $scope.settings.filter.pageNumber = 1;
            $scope.getItems();
          }
        }, (error) => {
          // ?
        });
      };

      $scope.getItemById = (id) => {
        for (let item in $scope.items) {
          if ($scope.items[item]._id === id) {
            $scope.selectedItem = $scope.items[item];
          }
        }
      };

      $scope.settings = {
        filter: {
          user: this.storeService.getCurrentUser().sub,
          _id: '',
          status: '',
          number: decodeURIComponent($stateParams.numeroFattura),
          idSdi: '',
          sendingId: '',
          object: '',
          dataFrom: '',
          dataTo: '',
          cessionary: '',
          fiscalId: '',
          fiscalCode: '',
          receiverCode: '',
          reference: '',
          onlyLastVersion: true,
          invoice_type: 'PR',
          pageNumber: 1,
          pageSize: 100
        },
        sortField: '_id',
        sortDirection: -1,
        pageSizes: [20, 50, 100]
      };

      $scope.getItems = () => {
        if (processingRequest) {
          return;
        }

        processingRequest = true;
        archiSmallServices.getFatturazioneDocuments($scope.settings.filter, $scope.settings.sortField, $scope.settings.sortDirection)
          .then((res) => {
            const response = JSON.parse(JSON.stringify(res)) as IResultResponse<IFatturaAttivaItem>;

            if (response.Result === 1) {

              $scope.settings.itemsCount = response.itemsCount;

              $scope.items = response.resultList;

              $scope.moreDataToLoad = $scope.items.length < $scope.settings.itemsCount;
            }

            $scope.selectedFatture = [];
            processingRequest = false;
          }, (error) => {
            this.alertService.alert('error', error);
            processingRequest = false;
          });
      };

      $scope.checkIfSelectedDocumentStatusIsOk = (selectedItems: string[], PackageType) => {
        for (let i = 0; i < selectedItems.length; i++) {
          for (let j = 0; j < $scope.items.length; j++) {
            if ($scope.items[j]._id === selectedItems[i]) {
              if ($scope.items[j].status === $scope.documentStatuses[DocumentStatus.PresoInCarico].name) {
                this.alertService.alert('warning', 'La Fattura con stato \'Presa in carico\' non è disponibile per il download.');
                return true;
              }
            }
          }
        }
      };

      $scope.getItems();

      $scope.clearFilter = () => {
        $scope.settings.filter.status = '';
        $scope.settings.filter.number = '';
        $scope.settings.filter.idSdi = '';
        $scope.settings.filter.dataFrom = '';
        $scope.settings.filter.dataTo = '';
        $scope.settings.filter.sendingId = '';
        $scope.settings.filter.object = '';
        $scope.settings.filter.cessionary = '';
        $scope.settings.filter.fiscalId = '';
        $scope.settings.filter.fiscalCode = '';
        $scope.settings.filter.receiverCode = '';
        $scope.settings.filter.reference = '';
        $scope.settings.filter.onlyLastVersion = true;
        $scope.settings.filter.sendingId = '';
        $scope.settings.filter.pageNumber = 1;
        $scope.settings.filter.option = '';

        $scope.items = [];
        $scope.moreDataToLoad = true;
        $scope.getItems();
      };

      $scope.statusList = ['Generata', 'Trasmessa allo SdI', 'Scartata', 'Non ancora consegnata', 'Consegnata', 'Accettata', 'Rifiutata', 'Decorsi i termini', 'Non recapitabile', 'Presa in carico', 'Rielaborata', 'SCARTATA DA ARCHISMALL'].sort((a, b) => {
        return a.localeCompare(b);
      });

      $scope.WorkerFatturazioneGeneratePackageModal = (PackageType, docId) => {
        if (docId !== undefined) {
          // one document
          // if is requested DIP download of ONLY ONE doc
          // we verify if the DIP is set
          // and we download it in case of true

          let indexes = $.map($scope.items, (obj, index) => {
            if (obj._id === docId) {
              return index;
            }
          });
          if (indexes.length !== 1) {
            return;
          }

          if ($scope.items[indexes[0]].DIP.Status === 2) {
            this.fileService.downloadFile($scope.items[indexes[0]].DIP.FilePath);
            return;
          } else {
            if ($scope.items[indexes[0]].DIP.Status === 1) {
              return;
            }
            $scope.items[indexes[0]].DIP.Status = 1;
            archiSmallServices.updateConservazioneDIPStatus($scope.items[indexes[0]])
              .then((response: any) => {
                $scope.getItems();
                let WorkerModal = $uibModal.open({
                  animation: true,
                  component: 'workerFatturazioneGeneratePackagePRModalComponent',
                  windowClass: 'center-modal',
                  backdrop: 'static',
                  keyboard: false,
                  resolve: {
                    settings: {
                      'PackageType': PackageType,
                      'DocumentIds': [docId],
                      'user': this.storeService.getCurrentUser().sub
                    }
                  }
                });
              }, (error) => {
                this.alertService.alert('error', error);
              });
          }
        } else {// multiple documents
          if ($scope.selectedItems.length === 0) {
            return;
          }

          let packageType = '';

          switch (PackageType) {
            case 'FatturaPR-PDF':
              packageType = 'PDF';
              break;
            case 'FatturaPR-XML':
              packageType = 'XML';
              break;
          }

          if ($scope.checkIfSelectedDocumentStatusIsOk($scope.selectedItems, packageType)) {
            return;
          }

          let WorkerModal = $uibModal.open({
            animation: true,
            component: 'workerFatturazioneGeneratePackagePRModalComponent',
            windowClass: 'center-modal',
            backdrop: 'static',
            keyboard: false,
            resolve: {
              settings: {
                'PackageType': PackageType,
                'DocumentIds': $scope.selectedItems,
                'user': this.storeService.getCurrentUser().sub
              }
            }
          });
        }
      };

      $scope.downloadFatture = (xml: boolean) => {
        if ($scope.selectedFatture.length === 1) {
          if (xml) {
            archiSmallServices.downloadFatturaXml($scope.selectedFatture[0]._id, $scope.selectedFatture[0].filePathXML.split('/').pop());
          } else {
            this.fileService.downloadFile(xml ? $scope.selectedFatture[0].filePathXML : $scope.selectedFatture[0].filePathPDF);
          }
        } else {

          if (xml) {
            // console.log('gestione xml');

            // gestisci download xml
            $uibModal.open({
              animation: true,
              component: 'workerFatturazioneDownloadFatturePRModalComponent',
              windowClass: 'center-modal',
              backdrop: 'static',
              keyboard: false,
              resolve: {
                settings: {
                  type: 'fa_xml',
                  fatture: $scope.selectedFatture.filter(item =>
                    !(item.status === $scope.documentStatuses[$rootScope.DocumentStatus.PresoInCarico].name
                      || item.status === $scope.documentStatuses[$rootScope.DocumentStatus.ErroreTrasmissione].name
                      || item.status === $scope.documentStatuses[$rootScope.DocumentStatus.ScartataArchismall].name)),
                  user: this.storeService.getCurrentUser().sub
                }
              }
            });
          } else {
            // console.log('gestione pdf');

            // gestisci download pdf
            $uibModal.open({
              animation: true,
              component: 'workerFatturazioneDownloadFatturePRModalComponent',
              windowClass: 'center-modal',
              backdrop: 'static',
              keyboard: false,
              resolve: {
                settings: {
                  type: 'fa_pdf',
                  fatture: $scope.selectedFatture.filter(item =>
                    !(item.status === $scope.documentStatuses[$rootScope.DocumentStatus.PresoInCarico].name
                      || item.status === $scope.documentStatuses[$rootScope.DocumentStatus.ErroreTrasmissione].name
                      || item.status === $scope.documentStatuses[$rootScope.DocumentStatus.ScartataArchismall].name)),
                  user: this.storeService.getCurrentUser().sub
                }
              }
            });
          }
        }
      };

      $scope.addOrRemoveSelectedItem = (item: IFatturaAttivaItem) => {
        $scope.selectedFatture = $scope.selectedFatture.filter(item => item.isSelected);
        if (item.isSelected && !$scope.selectedFatture.includes(item)) {
          $scope.selectedFatture = $scope.selectedFatture.concat(item);
        }
        // console.log($scope.disableDownloadFile(), $scope.disableNotifications(), $scope.selectedFatture.length === 1);
        // $scope.selectedItem = item.isSelected ? item : undefined;
      };

      $scope.disableDownloadFile = () => {
        return $scope.selectedFatture.every(item =>
          item.status === $scope.documentStatuses[$rootScope.DocumentStatus.PresoInCarico].name
          || item.status === $scope.documentStatuses[$rootScope.DocumentStatus.ErroreTrasmissione].name
          || item.status === $scope.documentStatuses[$rootScope.DocumentStatus.ScartataArchismall].name);
      };

      $scope.disableNotifications = () => {
        return ($scope.selectedFatture.length === 1 ? $scope.disableDownloadFile() : true);
      };

      $scope.exportCsv = () => {
        fileService.downloadCsv(archiSmallServices.getFatturazioneDocumentsCsv($scope.settings.filter, $scope.settings.sortField, $scope.settings.sortDirection));
      };

      $scope.loadExistingXml = (stringXml: string) => {
        try {
          let fatturaPA: any;
          let parser = new xml2js.Parser({explicitRoot: false, explicitArray: false});

          parser.parseString(stringXml, (err, result) => {
            fatturaPA = result;
          });
          return fatturaPA.FatturaElettronicaBody[0].DatiGenerali.DatiGeneraliDocumento.TipoDocumento === 'TD04';
        } catch (error) {
          console.error(error);
        }
        return false;

      };

    }

    statoDescription = (status: string, number: string, erroreMessageDetails?: string) => {
      switch (status) {
        case 'Scartata':
          return this.trusted['scartata' + number] || (this.trusted['scartata' + number] = this.$sce.trustAsHtml('<span><b>Notifica di scarto</b></span><br/><span>Abbiamo ricevuto una notifica di scarto dal Sistema di Interscambio per la fattura numero <b>' + number + '</b>. </span><br/><span> Verifica il motivo dello scarto e correggi l’errore; <br/><b>Ricorda che puoi modificare la fattura e reinviarla selezionando \'Reinvia Fattura\'.</b></span>'));
        case 'Trasmessa allo SdI':
          return this.trusted['trasmessa' + number] || (this.trusted['trasmessa' + number] = this.$sce.trustAsHtml('<span><b>Trasmessa allo SdI</b></span>'));
        case 'Generata':
          return this.trusted['generata' + number] || (this.trusted['generata' + number] = this.$sce.trustAsHtml('<span><b>Generata</b></span>'));
        case 'Non ancora consegnata':
          return this.trusted['non-consegnata' + number] || (this.trusted['non-consegnata' + number] = this.$sce.trustAsHtml('<span><b>Notifica mancata consegna</b></span><br/><span> Abbiamo ricevuto una notifica di mancata consegna per la tua fattura numero <b>' + number + '</b>. </span><br/><span>La notifica di mancata consegna è inviata al trasmittente del file FatturaPR quando il Sistema di Interscambio (SdI) non riesce a consegnare il file al destinatario.<br/>Il SdI proverà nuovamente l\'inoltro del file FatturaPR al destinatario.<br/>Se al consegna riesce, il SdI invia al mittente una ricevuta di consegna, altrimenti, trascorsi 10 giorni dall\'invio della notifica di mancata consegna, invia al mittente un\'attestazione di avvenuta trasmissione della fattura con impossibilità di recapito. Attendi riscontro dal SdI.</span>'));
        case 'Consegnata':
          return this.trusted['consegnata' + number] || (this.trusted['consegnata' + number] = this.$sce.trustAsHtml('<span><b>Ricevuta di consegna:</b></span><br/><span>La tua fattura numero <b>' + number + '</b>  è stata correttamente consegnata. Attendi l\'esito dal destinatario.</span>'));
        case 'Accettata':
          return this.trusted['accettata' + number] || (this.trusted['accettata' + number] = this.$sce.trustAsHtml('<span><b>Accettata</b></span><br/>'));
        case 'Rifiutata':
          return this.trusted['rifiutata' + number] || (this.trusted['rifiutata' + number] = this.$sce.trustAsHtml('<span><b>Notifica di scarto esito committente</b></span><br/><span> Abbiamo ricevuto una notifica di scarto esito per la tua fattura numero <b>' + number + '</b>. </span><br/><span>La notifica di scarto esito è inviata dal Sistema di Interscambio per segnalare una non ammissibilità o non conformità della fattura rilevata dal destinatario.</span><br/><span><b>Clicca su \'Reinvia Fattura\' potrai semplicemente correggere la fattura e inoltrarla nuovamente.</b><br/><span>Ricorda che la fattura è da considerarsi regolarmente emessa, per cui verifica col destinatario il motivo dello scarto e se è stata registrata contabilmente. In tal caso dovrai emettere nota di credito e nuova fattura.</span>'));
        case 'Decorsi i termini':
          return this.trusted['termini' + number] || (this.trusted['termini' + number] = this.$sce.trustAsHtml('<span><b>Notifica di decorrenza termini</b></span><br/><span> Abbiamo ricevuto una notifica di decorrenza termini per la tua fattura numero <b>' + number + '</b>. </span><br/><span>La notifica di decorrenza termini è un messaggio che il SdI invia sia al trasmittente sia al destinatario nel caso in cui non abbia ricevuto notifica di esito dal destinatario entro 15 giorni dalla ricevuta di consegna.</span><br/><span>Con questa notifica SdI comunica a te ed al destinatario che non è più possibile rispondere alla fattura o reinviare la fattura.</span><br/><span>La fattura si considera emessa ma non è nè accettata nè rifiutata. Verifica con il destinatario lo stato della fattura e considerate se è necessario l\'invio di Nota di Credito e nuova fattura. </span>'));
        case 'Non recapitabile':
          return this.trusted['non-recapitabile' + number] || (this.trusted['non-recapitabile' + number] = this.$sce.trustAsHtml('<span><b>Attestazione di avvenuta trasmissione della fattura con impossibilità di recapito</b></span><br/><span> Abbiamo ricevuto una notifica di impossibilità di recapito </b> per la tua fattura numero <b>' + number + '</b>. </span><br/><span>Questa notifica viene consegnata trascorsi i 10 giorni dall\'invio della notifica di mancata consegna per cause non imputabili al trasmittente, ricorda che la fattura è da considerarsi emessa per cui la fattura non potrà essere reinviata allo SdI. Per questo motivo verifica con il destinatario i contatti di  trasmissione e ricorda di stornare la fattura dalla tua contabilità. A seguito di queste operazioni potrai trasmettere una nuova fattura.</span>'));
        case 'Presa in carico':
          return this.trusted['presa' + number] || (this.trusted['presa' + number] = this.$sce.trustAsHtml('<span><b>Presa in carico</b></span><br/><span>La tua fattura numero <b>' + number + '</b> è stata presa in carico e a breve verrà inviata allo SDI.</span>'));
        case 'ERRORE TRASMISSIONE':
          return this.trusted['errore' + number] || (this.trusted['errore' + number] = this.$sce.trustAsHtml('<span><b>ERRORE TRASMISSIONE</b></span><br/><span>Verificare il file xml. Aprire un ticket <a href="mailto:helparchismall@smeup.com?subject=Richiesta assistenza"> Contatta il supporto tecnico</a>.</span>' + (erroreMessageDetails ? ('<br/><strong>Errore:</strong><br/>' + erroreMessageDetails) : '')));
        case 'Rielaborata':
          return this.trusted['rielaborata' + number] || (this.trusted['rielaborata' + number] = this.$sce.trustAsHtml('<span><b>Rielaborata</b></span>'));
        case 'SCARTATA DA ARCHISMALL':
          return this.trusted['errorearch' + number] || (this.trusted['errorearch' + number] = this.$sce.trustAsHtml('<span><b>SCARTATA DA ARCHISMALL</b></span>' + (erroreMessageDetails ? ('<br/><strong>Errore:</strong><br/>' + erroreMessageDetails) : '')));
      }
    }

    rectifyInvoice(item: IFatturaAttivaItem) {
      switch (item.uploadType) {
        case 1:
          this.$state.go('home.componi-fattura-pr-semplice', {xmlpath: item.filePath});
          break;
        case 2:
          this.$state.go('home.pr-componi-fattura-avanzata', {xmlpath: item.filePath});
          break;
        case 3:
          this.$state.go('home.pr-carica-fattura');
          break;
      }
    }

    generateNc(item: IFatturaAttivaItem) {
      switch (item.uploadType) {
        case 1:
          this.$state.go('home.componi-fattura-pr-semplice', {xmlpath: item.filePath, requestNotaCredito: true});
          break;
        case 2:
          this.$state.go('home.pr-componi-fattura-avanzata', {xmlpath: item.filePath, requestNotaCredito: true});
          break;
        case 3:
          this.$state.go('home.pr-carica-fattura');
          break;
      }
    }

    openExportModal(size: string) {
      this.$uibModal.open({
        animation: true,
        component: 'exportComponent',
        size: size,
        windowClass: 'center-modal',
        resolve: {
          packageTypePrefix: () => {
            return 'FatturaPR';
          },
          user: () => {
            return this.storeService.getCurrentUser().sub;
          }
        }
      });
    }

    openRiferimentoModal(size: string, referenceValue: any, option: any, event: Event) {
      let RiferimentoModal = this.$uibModal.open({
        animation: true,
        component: 'riferimentoPRModalComponent',
        size: size,
        backdrop: 'static',
        keyboard: false,
        windowClass: 'center-modal',
        resolve: {
          referenceValue: () => {
            return referenceValue;
          },
          option: () => {
            return option;
          }
        }
      });
      event.stopPropagation();
      RiferimentoModal.result.then(() => {
        // ??
      }, () => {
        // ??
      });
    }

    openNotificationsModal(size: string, item: any) {
      this.$uibModal.open({
        animation: true,
        component: 'notificationsModalComponent',
        size: size,
        windowClass: 'center-modal',
        resolve: {
          invoice: () => {
            return item;
          },
          stato: () => {
            return this.statoDescription;
          }
        }
      });
    }

    contextMenuOptions(itemDocument: any): Array<Array<any>> {
      const contextMenuItemTitle = '<span><strong>Fattura ' + itemDocument.number + '</strong></span>';
      const contextMenuItemPDF = '<i class=\'icon-icon_file_pdf\'></i> <span>Scarica File PDF</span>';
      const contextMenuItemXML = '<i class=\'icon-icon_file_xml\'></i> <span>Scarica File XML</span>';
      const contextMenuItemNotifications = '<i class=\'icon-icon_bell\'></i> <span>Notifiche</span>';
      const contextMenuItemPreview = '<i class=\'fa fa-eye\'></i> <span>Anteprima</span>';
      let contextMenuDownloadAttachment;
      if (itemDocument.hasAttachment === false) {
        contextMenuDownloadAttachment = '<i class=\'icon-icon_file link-disabled\'></i> <span class="link-disabled">Scarica Allegato</span>';
      } else {
        contextMenuDownloadAttachment = '<i class=\'icon-icon_file\'></i> <span class="">Scarica Allegato</span>';
      }
      return [
        [contextMenuItemTitle, ($itemScope) => {
          //
        }],
        null,
        [contextMenuItemPDF, ($itemScope) => {
          this.fileService.downloadFile($itemScope.item.filePathPDF);
        }],
        null,
        [contextMenuItemXML, ($itemScope) => {
          this.archiSmallServices.downloadFatturaXml($itemScope.selectedFatture[0]._id, $itemScope.selectedFatture[0].filePathXML.split('/').pop());
        }],
        null,
        [contextMenuItemNotifications, ($itemScope) => {
          this.openNotificationsModal('md', $itemScope.item);
        }],
        null,
        [contextMenuItemPreview, ($itemScope) => {
          this._previewService.showPreview($itemScope.item, this.previewModal);
        }],
        null,
        [contextMenuDownloadAttachment, ($itemScope) => {
          this.fileService.downloadAttachment($itemScope.item);
        }]
      ];
    }

    private previewModal = (item, type) => {
      this.$uibModal.open({
        animation: true,
        component: 'previewModalComponent',
        controllerAs: 'vm',
        size: 'preview',
        resolve: {
          path: () => {
            return item.filePathPDF;
          },
          type: () => {
            return type;
          }
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/visualizza-stato-fatture-pr/visualizza-stato-fatture-pr.ts